module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de permisos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Tipo")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroTipo),
      expression: "filtroTipo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroTipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o, key) {
    return _c('option', {
      domProps: {
        "value": +o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Código de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtroMes)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroMes = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroYear),
      expression: "filtroYear"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtroYear)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroYear = $event.target.value
      }
    }
  })])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Excel")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarNuevoExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Nuevo reporte")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.solicitudes.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Adjunto")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_c('span', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Fecha")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))])])])], 2), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])]], 2)])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('div', {
      key: o + index + '',
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_c('span', {
      staticClass: "is-bold hint--right",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])]], 2)]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Fecha")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))])])]), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e()], 2)])
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay permisos que cumplan con los siguientes filtros")])])])], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221aa8d7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Permisos_Reporte.vue
// module id = 836
// module chunks = 0